import styled, { css } from 'styled-components'

import { IconButton, mainColors, SMedium } from '@avantstay/backoffice-core'

// The core modal card keeps 30px above and below; the header is 65px with its border.
const IMAGE_MAX_HEIGHT = 'calc(100vh - 60px - 65px)'
const IMAGE_MAX_WIDTH = 'min(900px, calc(100vw - 32px))'

export const Dialog = styled.div`
  display: flex;
  flex-direction: column;
  width: fit-content;
  min-width: min(400px, calc(100vw - 32px));
  height: 100%;
  outline: none;
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  height: 64px;
  padding: 0 12px 0 20px;
  border-bottom: 1px solid ${mainColors.neutralMedium};
`

export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`

export const Title = styled(SMedium)`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

const headerButton = css`
  display: inline-flex;
  flex: none;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: 0;
  background: transparent;
  color: ${mainColors.neutralExtraDark};
  cursor: pointer;

  &:hover {
    color: ${mainColors.neutralExtremelyDark};
  }

  &:focus-visible {
    outline: 2px solid ${mainColors.accentMedium};
    outline-offset: 2px;
  }
`

export const HeaderButton = styled.button`
  ${headerButton};

  svg {
    width: 20px;
    height: 20px;
  }
`

export const CloseButton = styled.button`
  ${headerButton};

  svg {
    width: 24px;
    height: 24px;
  }
`

export const Stage = styled.div`
  position: relative;
  display: grid;
  place-items: center;
  flex: 1;
  min-height: 240px;
  background: ${mainColors.neutralExtraLight};
  text-align: center;
`

export const Image = styled.img`
  display: block;
  max-width: ${IMAGE_MAX_WIDTH};
  max-height: ${IMAGE_MAX_HEIGHT};
`

const disabledLook = css`
  &[data-disabled='true'] {
    opacity: 0.4;
    cursor: default;
  }
`

const arrow = css`
  ${disabledLook};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
`

export const PreviousButton = styled(IconButton.Secondary)`
  ${arrow};
  left: 12px;
`

export const NextButton = styled(IconButton.Secondary)`
  ${arrow};
  right: 12px;
`

export const ZoomControls = styled.div`
  position: absolute;
  right: 12px;
  bottom: 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const ZoomButton = styled(IconButton.Secondary)`
  ${disabledLook};
`
